import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useStateValue } from '../context/state.jsx';
import { closeOpenProject, focusProject, sourceFormatLabel } from '../util/openProject.js';

const OpenProjectStrip = () => {
	const [{ datasets, openDatasets, currentDataset }, dispatch] = useStateValue();
	const navigate = useNavigate();
	const datasetMap = datasets && typeof datasets === 'object' ? datasets : {};
	const openIds = (openDatasets || []).map(String).filter(id => datasetMap[id]);
	const focusedId = currentDataset || null;

	if (!openIds.length) {
		return null;
	}

	return (
		<div className="openProjectStrip" role="tablist" aria-label="Open projects">
			<span className="openStripLabel">Open</span>
			{openIds.map(datasetId => {
				const dataset = datasetMap[datasetId];
				const isFocused = String(focusedId) === String(datasetId);
				return (
					<div
						key={datasetId}
						className={`openTab${isFocused ? ' active' : ''}`}
						role="tab"
						aria-selected={isFocused}>
						<button
							type="button"
							className="openTabFocus"
							onClick={() => focusProject({ dispatch, navigate, datasetId, datasets: datasetMap })}>
							<span className="tabName">{dataset.Name}</span>
							<span className="sourceFormatBadge">{sourceFormatLabel(dataset)}</span>
						</button>
						<Link
							className="openTabGear"
							to={`/setup/projects/${datasetId}`}
							title={`Configure ${dataset.Name}`}
							aria-label={`Configure ${dataset.Name}`}>
							<span className="glyphicon glyphicon-cog"></span>
						</Link>
						<button
							type="button"
							className="openTabClose"
							title={`Close ${dataset.Name}`}
							aria-label={`Close ${dataset.Name}`}
							onClick={() => closeOpenProject({
								dispatch,
								navigate,
								datasetId,
								openDatasets: openIds,
								focusedDatasetId: focusedId,
								datasets: datasetMap
							})}>
							×
						</button>
					</div>
				);
			})}
		</div>
	);
};

export default OpenProjectStrip;
